import { Ord } from 'api/placements-api';

export const prepareTargetUrl = (targetUrl: string, ord?: Ord) => {
  const url = new URL(targetUrl);

  const isLemanaPro = /lemanapro/i.test(url.hostname);

  if (ord) {
    url.searchParams.set('erid', ord.eridToken);
  }

  return isLemanaPro ? `${url.pathname}${url.search}` : url.toString();
};
